import axios from "axios"

export default ({
    namespaced: true,
    state: {
        employees: [],
        employee: {},
        currentPage: 1,
        search: '',
        size: 10,
        order: 'created_at',
        add: {},
        totalPages: 0,
        selectedDelete: [],
        errorMessages: []
    },
    mutations: {
        setAllEmployees(state, employees) {
            state.employees = employees
            state.totalPages = Math.ceil(employees.total / state.size) || 0
        },
        setEmployee(state, employee) {
            state.employee = employee
        }
    },
    actions: {
        async getAll({ commit, rootState, state }) {
            const filter = 'search=' + state.search + '&size=' + state.size + '&order=' + state.order + '&page=' + state.currentPage
            const url = rootState.baseUrl + '/api/v1/employees'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.get(url + '?' + filter, { headers: header })
                .then(response => {
                    commit('setAllEmployees', response.data)
                })
                .catch((error) => {
                    console.log(error)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                })
        },
        async add({ state, rootState }, params) {
            const url = rootState.baseUrl + '/api/v1/employees'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.post(url, params, { headers: header })
                .then(response => {
                    this.dispatch('employee/getAll')
                })
                .catch((error) => {
                    console.log("ERROR = ", error.response.data)
                    // this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                    state.errorMessages.push(error.response.data)
                })
        },
        async delete({ state, rootState }, data) {
            const url = rootState.baseUrl + '/api/v1/employees/'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await Promise.all(
                data.map(id => axios.delete(url + id, { headers: header, data: {} }))
            );
            await this.dispatch('employee/getAll')
        },
        async get({ commit, rootState, state }, data) {
            const url = rootState.baseUrl + '/api/v1/employees/'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.get(url + data, { headers: header })
                .then(response => {
                    commit('setEmployee', response.data)
                })
                .catch((error) => {
                    console.log(error)
                    // this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                })
        },
        async edit({ state, rootState }, params) {
            const id = state.employee.id
            // console.log(params)
            const url = rootState.baseUrl + '/api/v1/employees/' + id
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.patch(url, params, { headers: header })
                .then(response => {
                    this.dispatch('employee/getAll')
                })
                .catch((error) => {
                    console.log("ERROR = ", error.response.data)
                    // this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                    state.errorMessages.push(error.response.data)
                })
        },
        async createAccount({ rootState }, data) {
            const url = rootState.baseUrl + '/api/v1/employees/'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            try {
                await Promise.all(
                    data.map(id =>
                        axios.post(url + id + '/create-account', {}, { headers: header })
                    )
                );
                await this.dispatch('employee/getAll');
                console.log('All accounts created successfully.');
            } catch (error) {
                console.error('Error creating accounts:', error);
                throw error;
            }
        },
        async getAllEmployes({ commit, rootState, state }) {
            const filter = 'size=all'
            const url = rootState.baseUrl + '/api/v1/employees'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.get(url + '?' + filter, { headers: header })
                .then(response => {
                    commit('setAllEmployees', response.data)
                })
                .catch((error) => {
                    console.log(error)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                })
        },
    }
})